import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AndroidAppNativeService } from './android-app-native.service';

/** Sends `X-Android-App-Version` on every HTTP call when running in the Android WebView shell. */
@Injectable()
export class AndroidAppVersionInterceptor implements HttpInterceptor {
  static readonly HEADER_NAME = 'X-Android-App-Version';

  constructor(private readonly androidAppNative: AndroidAppNativeService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const version = this.androidAppNative.getAppVersion();
    if (!version || req.headers.has(AndroidAppVersionInterceptor.HEADER_NAME)) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          [AndroidAppVersionInterceptor.HEADER_NAME]: version,
        },
      })
    );
  }
}
